<template>
  <div class="reserve-option-stocks-container">
    <admin-form-item label="필수옵션" v-if="opt1.length>0">
      <table>
        <tr>
          <th v-for="(h,idx) in computedHeaders" :key="`th-1-${idx}`" :style="`width:${h.size}%`"
              :colspan="colSpan(idx)">{{ h.name }}</th>
        </tr>
        <tr v-for="(item,idx) in opt1" :key="`opt1-${idx}`">
          <td v-for="(opt,optIdx) in item.options" :key="`opt-child-${optIdx}`">{{ opt.name }}</td>
          <td v-if="limitType===1">
            <div class="flex-center">
              <div>
                <input type="number" v-model.number="item.stock" style="width:80px" :disabled="!item.enable_stock">
                <div class="flex-center" style="margin-top:4px">
                  <lp-check-bool :checked-val="!item.enable_stock"
                                 @onCheck="res => item.enable_stock = !res"
                                 :labelStyle="{fontSize: '13px', color:'#787878'}"
                                 label="무한대"></lp-check-bool>
                </div>
              </div>
            </div>
          </td>
          <!-- <td>{{ currencyNum(item.ordered_count) }}</td> -->
          <td>+{{ currency(item.price) }}</td>
          <td>
            <div class="flex-center">
              <div class="flex" style="text-align: left">
                <div>
                  <div class="size-13 sub1">최소</div>
                  <input type="number" v-model.number="item.options[0].minimum" style="width:80px">
                </div>
                <div style="padding:23px 12px 0 12px">~</div>
                <div>
                  <div class="size-13 sub1">최대</div>
                  <input type="number" v-model.number="item.options[0].maximum" style="width:80px">
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </admin-form-item>

    <admin-form-item label="선택옵션" style="margin-top: 20px" v-if="opt2.length>0">
      <table>
        <tr>
          <th v-for="(h,idx) in computedHeaders" :key="`th-1-${idx}`" :style="`width:${h.size}%`">{{ h.name }}</th>
        </tr>
        <tr v-for="(item,idx) in opt2" :key="`opt2-${idx}`">
          <td>{{ item.options[0].name }}</td>
          <td v-if="limitType===1">
            <div class="flex-center">
              <div>
                <input type="number" v-model.number="item.stock" style="width:80px" :disabled="!item.enable_stock">
                <div class="flex-center" style="margin-top:4px">
                  <lp-check-bool :checked-val="!item.enable_stock"
                                 @onCheck="res => item.enable_stock = !res"
                                 :labelStyle="{fontSize: '13px', color:'#787878'}"
                                 label="무한대"></lp-check-bool>
                </div>
              </div>
            </div>
          </td>
          <!-- <td>{{ currencyNum(item.ordered_count) }}</td> -->
          <td>{{ currency(item.price) }}</td>
          <td>
            <div class="flex-center">
              <div class="flex" style="text-align: left">
                <div>
                  <div class="size-13 sub1">최소</div>
                  <input type="number" v-model.number="item.options[0].minimum" style="width:80px">
                </div>
                <div style="padding:23px 12px 0 12px">~</div>
                <div>
                  <div class="size-13 sub1">최대</div>
                  <input type="number" v-model.number="item.options[0].maximum" style="width:80px">
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </admin-form-item>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  export default {
    name: 'ReserveOptionStocks',
    components: {LpCheckBool},
    props: {
      reservePolicy: {
        type: Object
      },
      stocks: {
        type: Array
      }
    },
    created() {

    },
    data() {
      return {
        headers: [
          {
            name: '옵션명',
            size: 20
          },
          {
            name: '모집인원',
            size: 5
          },
          // {
          //   name: '신청인원',
          //   size: 5
          // },
          {
            name: '추가 가격',
            size: 10
          },{
            name: '1회 구매 수량제한',
            size: 15
          },

        ]
      }
    },
    computed: {
      limitType() {
        return this.reservePolicy.limit_type;
      },
      computedHeaders() {
        return this.reservePolicy.limit_type === 0 ?
            this.headers.filter(i => i.name !== '모집인원') : this.headers
        // return this.headers;
      },
      opt1() {
        return this.stocks.filter(i => i.option_type === 0);
      },
      opt2() {
        return this.stocks.filter(i => i.option_type === 1);
      }
    },
    methods: {
      colSpan(idx) {
        if(idx === 0) {
          return this.opt1[0].options.length;
        } else {
          return 1;
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .reserve-option-stocks-container
    th
      background-color #f5f5f5

    th,td
      text-align center !important
      vertical-align middle

    input[type=number]
      text-align left
      padding-left 8px
</style>
